import { useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { getFollowUpsAdmin } from "../connections/getApi";
import { setError, setLoading } from "../redux/slices/prescriptionSlice";
const UseFetchFollowUpsList = (page, pageSize, type) => {
    const dispatch = useDispatch();
    return useQuery({
        queryKey: ["getFollowUpsAdmin", page, pageSize, type],
        queryFn: () => getFollowUpsAdmin(page, pageSize, type),
        enabled: !!page || !!pageSize || !!type,
        onError: () => {
            dispatch(setError(true));
            dispatch(setLoading(false));
        },
        onSettled: () => {
            dispatch(setLoading(false));
        },
    });
};

export default UseFetchFollowUpsList;
